<template>
  <div class="beixing">
    <div class="banner">
      <div class="img">
        <img src="../../../assets/myyq.jpg" />
        <!-- <img :src="this.$store.getters.banner[this.$route.path]" /> -->
      </div>
      <div class="list">
        <div class="listContent">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height: 100vh;">
            <van-list v-model="loading" :finished="finished" @load="onLoad">
              <div class="item" v-for="(item, index) in list" :key="index">
                <a :href="'/bxDetail/' + item.id">
                  <div class="top">
                    <div class="img">
                      <div class="imgDiv">
                        <!-- <img :src="../../../assets/p1.jpg" /> -->
                        <img :src="item.firstPhoto" />
                      </div>
                    </div>
                    <div class="content">
                      <div class="title">{{ item.steleName }}</div>
                      <div class="tag">
                        {{ $join(item.labels, ' | ') }}
                      </div>
                      <div class="zixun">
                        咨询价格
                      </div>
                    </div>
                  </div>
                  <div class="bottom">
                    <span>已被咨询{{ item.consultCount }}次</span>
                    <span>在售墓地{{ item.tombCount }}个</span>
                  </div>
                </a>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'beixingIndex',
  components: {},
  data() {
    return {
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
      page: 1,
    }
  },
  methods: {
    getData() {
      var that = this
      this.$queryPage(
        'OweStele',
        { page: that.page, size: 10 },
        ['id', 'firstPhoto', 'steleName', 'labels', 'consultCount', 'tombCount'],
        function(res) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              that.list.push(item)
            })
            that.loading = false
            that.page++
          } else {
            that.finished = true
            that.loading = false
            that.isLoading = false
            that.$notify({
              message: '没有更多数据啦~',
              color: '#ad0000',
              background: '#ffe1e1',
            })
          }
        }
      )
    },
    onLoad() {
      let that = this
      setTimeout(() => {
        if (that.isLoading) {
          that.isLoading = false
        }
        this.getData()
      }, 500)
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.onLoad()
    },
  },
  created() {
    this.page = 1
    this.list = []
    this.getData()
  },
}
</script>

<style>
.beixing .banner {
}
.beixing .banner .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.beixing .banner .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}

.beixing .list {
  margin-top: 20px;
}

.beixing .content {
  width: 5.46667rem;
}
.beixing .htitle {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
  display: block;
  margin-top: 0.13333rem;
  margin-bottom: 0.43rem;
}
.beixing .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.42667rem;
  font-weight: 500;
  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.13333rem;
}
.beixing .tag {
  margin-bottom: 0.58667rem;
  font-size: 0.32rem;
  color: #666;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  word-wrap: break-word;

  word-break: break-all;
  width: 205px;
}
.beixing .item {
  padding: 5px 20px;

  height: 156px;
}

.beixing .item .top {
  display: flex;
}
.beixing .item .top .content {
  position: relative;
  padding: 0 10px;
  flex: 1;
}
.beixing .item .top .content .zixun {
  font-size: 0.37333rem;
  color: #dea767;
  line-height: 0.53rem;
  position: relative;
  display: inline;
}
.beixing .item .top .content .zixun::after {
  content: '';
  width: 0.13333rem;
  height: 0.18667rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcBAMAAACT9IJTAAAALVBMVEUAAAD/v3//zJn/qn/fqGffqWnfp2jeqGffqGffp2jfqGffqGjfp2jep2fep2djMZ0yAAAADnRSTlMABAUGT1Cpqq2ur7Cx+ksIhDEAAAB8SURBVBjTY2BgLWKAgdhXClAW6713i6BM33fvXkOF8969e7cJwtR6BxdmWocQ1kQSngdkH0IIv0ESPgwR1gAJG0CE+7AK6wCZLwTACs4BmY1gQW2QINg0pn1AZhNc8CVCcBLclVDBdVgEwR6aBPX7u3cw3yN5HilIEAEFAPLwX7r0H2r8AAAAAElFTkSuQmCC)
    no-repeat 50%/100% 100%;
  position: absolute;
  right: -0.27rem;
  top: 50%;
  transform: translateY(-50%);
}

.beixing .item .top .img {
  width: 3.46667rem;
  height: 2.34667rem;
  border-radius: 0.05333rem;
  overflow: hidden;
}
.beixing .item .top .imgDiv {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.beixing .item .top .img img {
  width: 100%;
  object-fit: cover;
  height: 100%;
}
.beixing .item .bottom {
  border-bottom: 1px solid #dfdfdf;
  font-size: 0.32rem;
  color: #666;
  line-height: 0.7rem;
  margin-top: 0.4rem;

  display: flex;
  justify-content: space-between;
  height: 0.7rem;
}
.beixing .item .content {
  position: relative;
  color: #666;
  font-size: 14px;
}
.beixing .item .bottom .content {
  position: relative;
}
.beixing .item .bottom .left {
  position: absolute;
  left: 0;
}
.beixing .item .bottom .right {
  position: absolute;
  right: 0;
}
.beixing .item .top .content {
  text-align: left;
}
</style>
